import script from "./FilterArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilterArea.vue?vue&type=script&setup=true&lang=ts"

import "./FilterArea.vue?vue&type=style&index=0&id=732df1f7&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-732df1f7"]])

export default __exports__